export const BatchTransferABI = {
  abi: [
    {
      inputs: [
        { internalType: "contract IERC721", name: "nft", type: "address" },
        { internalType: "address[]", name: "to", type: "address[]" },
        { internalType: "uint256[]", name: "ids", type: "uint256[]" },
      ],
      name: "bulkTransfer",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ],
};
